import { render } from "./klb-basic.vue?vue&type=template&id=1de6440a&scoped=true"
import script from "./klb-basic.vue?vue&type=script&lang=js"
export * from "./klb-basic.vue?vue&type=script&lang=js"

import "./klb-basic.vue?vue&type=style&index=0&id=1de6440a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de6440a"]])

export default __exports__